define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "تسجيل مستخدم أخر",

    'incrowd_stats.num_responders': "{{num}} مِهْنِيُّ الرِّعايَةِ الصِّحِّيَّة الخبراء ",
    'incrowd_stats.num_answers': "{{num}} أسئلة تم الاجابة عنها ",
    'incrowd_stats.time_to_complete': "{{num}} دقيقة لاستكمال الاستبيان تقريبًا ",

    // INCROWD
    'incrowd.about': "نبذة عن الشركة",
    'incrowd.contact': "تواصل معنا",
    'incrowd.press': "النشرات الإخبارية",
    'incrowd.careers': "الوظائف",
    'incrowd.terms': "الشروط",
    'incrowd.t_and_c': "الشروط والأحكام",
    'incrowd.faq': "الأسئلة المتكررة",
    'incrowd.privacy': "الخصوصية",
    'incrowd.copyright': "{{year}}  كافة الحقوق محفوظة لشركة إنكرود ",
    'incrowd.blog': "المدونات",
    'incrowd.support': "الدعم",
    'incrowd.info.ios': "هل تعلم أن الأطباء في شركة إنكرود يمكنهم الآن توجيه الاستفسارات مباشرة إلى زملائهم؟ قم بتجربة ذلك باستخدام < تطبيق InCrowd Ios >!",
    'incrowd.refer': "هل تود المشاركة في الاستبيانات التي نعرضها؟ قم الآن بـ < إحالة صديق>  للانضمام لمجموعتنا  وستجني 10 دولار أمريكي (أو ما يعادلها)، وبمجرد أن يجيب زملائك على الاستبيان،  فسيحصلون على مكافأة!",


    // GET STARTED (step 0)
    'getstarted.encourage.title': "استبيانات مصغرة",
    'getstarted.encourage.title.two': "تأثير كبير",
    'getstarted.encourage.subtitle': "أنضم إلى آلاف المهنيين المؤهلين العاملين في مجال الطب الذين لهم باع في تطوير المنتجات الجديدة ومعالجة المرضى من خلال الاستبيانات المُصغرة البسيطة، وفوق كل ذلك سندفع لك!",
    'getstarted.encourage.redirect_to_solutions': "لست من المهنيين العاملين في مجال الرعاية الصحية ولكن أود أن أتعرف على المزيد عن إنكرود (InCrowd) ؟",
    'getstarted.actions.title': "هل أنت من المهنيين المؤهلين العاملين في مجال الطب؟ ",
    'getstarted.actions.subtitle': "قم بالتسجيل اليوم وأبد في جني الأموال عن طريق الإجابة عن الاستبيانات المُصغرة المتعلقة بالرعاية الصحية. ",
    'getstarted.button.continue': "أبد الآن",
    'getstarted.referral': "قم بالاشتراك لكي تربح الأموال من إكمال الاستبيانات بالإضافة إلى علاوة الإحالة من%{referrerName}",
    'getstarted.complete_registration': " Complete your InCrowd registration and start receiving surveys today!",
    'getstarted.questions': "Have questions? Use the chat box on the bottom right of the screen, we're here to help.",

    'details.need_info_description': "نحتاج منك إلى القليل من البيانات لإعداد حسابك.",
    'details.profile_details': "بيانات الملف الشخصي",
    'details.address_information': "بيانات العنوان",
    'details.professional_info': "المعلومات المهنية",
    'details.heading.finally': "...وفي النهاية",
    'details.how_receive_surveys': "كيف تريد أن تستلم الإستطلاعات؟",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "الأسس",
    'professionchoice.encourage.subtitle': "هل وظيفتك غير مُدرجة؟ أخبرنا بها من <هنا> حتى نقوم بإخبارك عندما نقوم بإضافتها.",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "من أنت؟",
    'authentication.encourage.subtitle': "تحتاج شركة إنكورد للتحقق من هويتك ولكن لن نفصح عن بياناتك الشخصية أو نقوم بنشرها إلى الغير ",
    'authentication.actions.select_notifications': "قم باختيار الطريقة التي تود من خلالها تسلم الاستبيانات التي نطرحها",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "يرجى الانتظار بينما نقوم بالتحقق من معلوماتك",
    'validation.please_answer': "يرجى الإجابة عن الأسئلة التالية لمساعدتنا في التحقق من بياناتك الشخصية.",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "تأكيد",
    'confirmation.validation_success.subtitle': "تم الانتهاء من عملية تسجيلك، مرحبًا بك في InCrowd! ستصلك رسالة تأكيد قريبًا عن طريق البريد الإلكتروني و/أو الرسائل النصية. شكرًا على الانضمام إلينا!",
    'confirmation.validation_error.title': "خطأ",
    'confirmation.validation_error.subtitle': "نأسف, %{userFirstName},حدثت مشكلة أثناء التحقق من بياناتك الشخصية",
    'confirmation.actions_title': "ما التالي؟",
    'confirmation.go_to_your_profile': "الانتقال إلى ملف التعريف الخاص بك",
    'confirmation.validation_success.actions_subtitle': "أنت الآن بصدد استقبال استبياناتنا المُصغرة التي تستمر من 3 إلى 5 دقائق على مدار يومين وذلك عبر البريد الإلكتروني أو الرسائل النصية. ألا تود استقبال هذه الاستبيانات عن طريق الرسائل النصية بعد؟ يمكنك تغيير إعدادات التواصل في أي وقت وذلك عن طريق ملف التعريف الخاص بك على InCrowd.",
    'confirmation.validation_error.actions_subtitle': "يرجى استخدام مربع الدردشة المباشرة في الجزء الأيمن لأسفل الشاشة للتواصل مع أحد أعضاء فريق انكورد ومعالجة أي من المسائل العالقة.",
    'confirmation.referral.info.1': "في غضون %{payoutBusinessDays} أيام عمل بعد إكمال الاستبيان الثاني، فإنك أنت وكذلك الشخص الذي قمت بإحالته، <سيحصل كل منكم على %{currency}%{referralBonusAmount}>. سيتم إضافة %{currency}%{referralBonusAmount} إلى حساب المكافآت الخاص بك. يمكنك تسجيل الدخول إلى <الملف التعريفي> الخاص بك في أي وقت لتحديث المفضلات ومراجعة المكافآت والوصول إلى أي من الاستبيانات المفتوح التي تم دعوتك إليها.",
    'confirmation.referral.info.2': "الاسئلة ؟ <تواصل معنا>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "هل أنت مؤهل؟",
    'regftr.markets.accepting': "يتم حاليًا قبول إجابات إنكورد",
    'regftr.peers.title': "الأقران ",
    'regftr.peers.subtitle': "قم بمقارنة إجابتك إلى الإجابات التي قدمها أقرانك وتعلم من ردودهم. ",
    'regftr.invites.title': "الدعوات",
    'regftr.invites.subtitle': "يمكنك الآن الحصول على دعوات الاستبيانات الجديدة عن طريق البريد الإلكتروني أو على هاتفك وذلك لمضاعفة أرباحك.",
    'regftr.earnings.title': "الأرباح",
    'regftr.earnings.subtitle': "تحكم في أرباحك وبيانات المدفوعات الخاصة بك وتابعها.",
    'regftr.stats.title': "الحالة",
    'regftr.stats.subtitle': "قم بالدخول إلى لوحة المعلومات باستخدام بيانات الاستبيان وبيانات المستخدم الخاصة بك.",

    'contextual_help.sms': "ستتلقى إشعاراتِ الرسائل النصية القصيرة على هاتِفك المحمول لتتمكن من فتح استطلاعات الرأي الدقيقة الصغيرة. ستتمكن من خلال الرسائل الهاتفية القصيرة الولوج إلى استطلاعات الرأي أسرع من ذي قبل والفوز بجوائز ومُكافآتٍ أكثر. ستُحفظُ معلوماتُك بسرّيةٍ تامةٍ وسيتم استخدامها لدعوات استطلاعات الرأي فقط.",
    'contextual_help.specialty': " رجاءً قُم بإلحاق التخصصات التي لها علاقة برقم معرف المزود الوطني (NPI) والذي قد أكملت الزمالات فيه أو أي المجالات الطبية التي تندرج تحت تخصصك الأساسي. إذا أردت أن تُحدِث أية تغييرات في تخصصاتك مُستقبلًا، تواصل مع support@incrowdnow.com.",
    // USER
    'user(s)': "المستخدم |||| المستخدمون",
    'user.login': "تسجيل الدخول",
    'user.logout': "تسجيل الخروج",
    'user.register': "تسجيل الخروج",
    'user.invitations': "الدعوات",
    'user.email': "البريد الإلكتروني",
    'user.pass_word': "كلمة المرور",
    'user.mobile': "رقم الهاتف المتحرك",
    'user.mobile.hint': " يرجى إدخال رمز البلد(+%{phoneCode} من أجل %{countryName})",
    'user.title': "اللقب",
    'user.title_with_example': " اللقب (على سبيل المثال دكتور، السيدة/ السيد)",
    'user.first_name': "الاسم الأول",
    'user.last_name': "الاسم الأخير",
    'user.middle_name': "الاسم الأوسط",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "مستخدم",
    'user.anonymous_admin': "مستخدم رئيسي",
    'user.dashboard': "لوحة معلومات",
    'user.profile': "ملف التعريف",
    'user.profile.picture.upload': "رفع صورة ملف التعريف",
    'user.profile.picture.change': "تغيير",
    'user.primary_lang': "اللغة الرئيسية",
    'user.primary_lang?': "ما هي لغتك الرئيسية؟",
    'user.survey_langs?': "ما هي اللغات التي تتقنها؟",
    'user.notify_email': "الإبلاغ عن طريق البريد الإلكتروني",
    'user.notify_mobile': "الإبلاغ عن طريق الهاتف المتحرك",
    'user.contact_support': "الاتصال بالدعم",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': " يرجى<الاتصال بنا>.",
    'user.profession': "المهنة",
    'user.profession?': "ما هي مهنتك؟",
    'user.join_now': "أنضم الآن",
    'user.welcome_back': " مرحبًا بك من جديد!",
    'user.not_a_member?': "هل لست عضوًا حتى الآن",
    'user.accept_terms': " قبول الشروط",
    'user.accept_terms.yes': " قبلت <الشروط والأحكام >",
    'user.remember_me': "تذكرني على هذا الجهاز",
    'user.time_zone': "توقيت المنطقة",
    'user.payment.policy': "في كل مرة تصل فيها إلى مكافأة %{currency}25، سيتم إخطارك وستكون قادر على الاختيار من بين خيارات السداد التي نطرحها وذلك من خلال ملف التعريف الخاص بك على InCrowd. هل لديك أي استفسارات؟ يمكنك التواصل معنا عبر نافذة الدردشة الموجودة أدناه.",
    'user.policy.payment': "في كل مرة تصل فيها إلى مكافأة %{currency}%{marketThreshold} سيتم إخطارك وستكون قادر على الاختيار من بين خيارات السداد التي نطرحها وذلك من خلال ملف التعريف الخاص بك على InCrowd. هل لديك أي استفسارات؟ يمكنك التواصل معنا عبر نافذة الدردشة الموجودة أدناه.",
    'user.country.live_work?': "ما هي البلد التي تقطنها وتعمل بها؟",
    // FORMS
    'form.button.back': "عودة للخلف",
    'form.button.next': "التالي",
    'form.button.cancel': "إلغاء",
    'form.button.submit': "إرسال",
    'form.button.continue': "متابعة",
    'form.button.close': "إغلاق",
    'form.button.go!': "انتقال!",
    'form.button.complete!': "أكمل الآن!",
    'form.button.update': "تحديث",
    'form.button.finish': "إنجاز",
    'form.button.search': "بحث",
    'form.button.end': "النهاية",
    'form.search.no_matches': "تعذر العثور على نتائج مطابقة",
    'form.confirm_email': "قم بتأكيد عنوان البريد الإلكتروني",
    'form.confirm_pass_word': "تأكيد كلمة المرور",
    'form.required_fields': "الحقول المطلوبة",
    'form.nothing_selected': "لم يتم تحديد أي شيء",
    'form.confirm_field': "تأكيد %{formFieldLabel}",
    'form.choice.n/a': "لا شيء",
    'form.choice.yes': "نعم",
    'form.choice.no': "لا",
    'form.choice.blank_for_all': "أتركه فارغًا لتحديد الكل",
    'form.choices.select_all': "تحديد الكل",
    'form.choices.deselect_all': "إلغاء تحديد الكل ",
    'form.field.private': "حقل خاص",
    'user.error.dup_email': "يوجد مستخدم أخرى مُسجل باستخدام عنوان البريد الإلكتروني هذا. < هل ترغب في تسجيل الدخول بدلًا من ذلك؟>",
    'user.error.dup_sms': "يوجد مستخدم أخر مُسجل يحمل نفس رقم الهاتف المتحرك",
  }
})
